import script from "./MelView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MelView.vue?vue&type=script&setup=true&lang=ts"

import "./MelView.vue?vue&type=style&index=0&id=2c10ad9e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c10ad9e"]])

export default __exports__